import { render, staticRenderFns } from "./FormDetailConsult.vue?vue&type=template&id=76d4fcbd&scoped=true&"
import script from "./FormDetailConsult.vue?vue&type=script&lang=js&"
export * from "./FormDetailConsult.vue?vue&type=script&lang=js&"
import style0 from "./FormDetailConsult.vue?vue&type=style&index=0&id=76d4fcbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d4fcbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76d4fcbd')) {
      api.createRecord('76d4fcbd', component.options)
    } else {
      api.reload('76d4fcbd', component.options)
    }
    module.hot.accept("./FormDetailConsult.vue?vue&type=template&id=76d4fcbd&scoped=true&", function () {
      api.rerender('76d4fcbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/documents/FormDetailConsult.vue"
export default component.exports